import { createContext, useContext, useState } from 'react';
import { ClientFeedback } from '../types/feedbacks';

// declaring the context datatypes here
interface IClientFeedbackContext {
  clientFeedback: ClientFeedback | null;
  showClientFeedbackModal: boolean;
  setShowClientFeedbackModal: React.Dispatch<React.SetStateAction<boolean>>;
  setClientFeedback: React.Dispatch<
    React.SetStateAction<ClientFeedback | null>
  >;
}

// creating the context here
const ClientFeedbackContext = createContext<IClientFeedbackContext | null>(
  null
);

const ClientFeedbackProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  // integration of react hooks here
  const [showClientFeedbackModal, setShowClientFeedbackModal] =
    useState<boolean>(false);

  const [clientFeedback, setClientFeedback] = useState<ClientFeedback | null>(
    null
  );

  // rendering the context provider here
  return (
    <ClientFeedbackContext.Provider
      value={{
        clientFeedback,
        showClientFeedbackModal,
        setShowClientFeedbackModal,
        setClientFeedback,
      }}
    >
      {children}
    </ClientFeedbackContext.Provider>
  );
};

export default ClientFeedbackProvider;

// creating custom hook to access the client feedback context here
export const useClientFeedbackContext = () => {
  const context = useContext(ClientFeedbackContext);

  if (!context) {
    throw new Error(
      'useClientFeedbackContext must be within ClientFeedbackProvider!'
    );
  }

  return context;
};
